module.exports = __webpack_public_path__ + "img/05.c4df36e6.png";